/**
 * @generated SignedSource<<8395b7caf7d5d2c914c394d89d19b20e>>
 * @relayHash 374bea45411144fc6deb7cc33a9a4dce
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/441.0.0-2023-12-05T07:13:15.252Z/createProjectMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateProjectMutationInput = {
  clientMutationId?: string | null;
  installDate?: string | null;
  name: string;
  purchaserId?: string | null;
  shippingAddress?: AddressInput | null;
  userId: string;
};
export type AddressInput = {
  active?: boolean | null;
  addressBookMember?: boolean | null;
  city?: string | null;
  company?: string | null;
  contact?: string | null;
  country?: string | null;
  firstName?: string | null;
  label?: string | null;
  lastName?: string | null;
  line1?: string | null;
  line2?: string | null;
  phoneNumber?: string | null;
  state?: string | null;
  zipCode?: string | null;
};
export type createProjectMutation$variables = {
  input: CreateProjectMutationInput;
};
export type createProjectMutation$data = {
  readonly createProject: {
    readonly project: {
      readonly createdDate: string | null;
      readonly name: string | null;
      readonly portfolio: {
        readonly serviceId: string | null;
      } | null;
      readonly serviceId: string | null;
    } | null;
  } | null;
};
export type createProjectMutation = {
  response: createProjectMutation$data;
  variables: createProjectMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectMutationPayload",
        "kind": "LinkedField",
        "name": "createProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PortfolioV2",
                "kind": "LinkedField",
                "name": "portfolio",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createProjectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateProjectMutationPayload",
        "kind": "LinkedField",
        "name": "createProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Project",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PortfolioV2",
                "kind": "LinkedField",
                "name": "portfolio",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/441.0.0-2023-12-05T07:13:15.252Z/createProjectMutation",
    "metadata": {},
    "name": "createProjectMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "f7eb86f9af6b59958827eb9b812282a2";

export default node;
